import React, { FC } from 'react';
import Typography from '../Typography';

type Props = {
  typographyProps?: React.HtmlHTMLAttributes<HTMLParagraphElement>;
  anchorProps?: React.HtmlHTMLAttributes<HTMLAnchorElement>;
  variant?: TypographyVariantKeys;
  href?: string;
};

const Link: FC<Props> = ({
  children,
  typographyProps,
  anchorProps,
  variant = 'paragraph',
  href,
}) => (
  <a href={href} {...anchorProps}>
    <Typography variant={variant} {...typographyProps}>
      {children}
    </Typography>
  </a>
);

export default Link;
